import type { StaffMe } from '@central/api';
import { useRouteContext } from '@tanstack/react-router';

/** The signed-in staff user, from the authenticated layout route. */
export function useMe(): StaffMe {
  return useRouteContext({ from: '/app' }).me;
}

/** Owners and Admins write customers, licenses and environments; Support reads. */
export function useCanWrite(): boolean {
  const role = useMe().user.role;
  return role === 'Owner' || role === 'Admin';
}

/** A reseller's engineer: tier 1 for its reseller's customers, no licensing. */
export function useIsReseller(): boolean {
  return useMe().user.role === 'Reseller';
}
